import { Box, Divider, Skeleton } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';

type TrackersSkeletonProps = {
  count?: number;
};

const TrackersSkeleton = ({ count = 3 }: TrackersSkeletonProps) => {
  const theme = useTheme();
  return (
    <SkeletonList>
      {Array.from({ length: count }).map((_, index) => (
        <Box key={index}>
          <SkeletonRow>
            <Skeleton variant="rounded" width={45} height={45} />
            <SkeletonContent>
              <Skeleton variant="text" width="40%" height={24} sx={{ mb: 0.5 }} />
              <Skeleton variant="text" width="80%" height={18} />
            </SkeletonContent>
          </SkeletonRow>
          {index < count - 1 && <StyledDivider />}
        </Box>
      ))}
    </SkeletonList>
  );
};

const SkeletonList = styled(Box)({
  width: '100%',
});

const SkeletonRow = styled(Box)({
  display: 'flex',
  padding: 16,
  gap: 16,
  alignItems: 'center',
});

const SkeletonContent = styled(Box)({
  flex: 1,
});

const StyledDivider = styled(Divider)(({ theme }) => ({
  height: '1px',
  backgroundColor: theme.palette.custom.background,
  border: 'none',
}));

export default TrackersSkeleton;
